import { useMutation, useQueryClient } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import toaster from 'utils/toaster';

interface IUserDetail {
  firstName: string;
  lastName: string;
  phone: string;
}

const saveUserDetail = (postData: IUserDetail) => {
  return http().post(endpoints.profile.base, postData);
};

export function useSaveUserDetail() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: saveUserDetail,
    onSuccess: (data: any) => {
      queryClient.invalidateQueries({ queryKey: ['fetchUserDetails'] });

      if (data.message) {
        toaster.success({ description: data.message });
      }
    },
  });
}
